import { ReactNode, useCallback } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

interface MobileFilterDrawerProps {
  open: boolean;
  onClose: () => void;
  onApply: () => void;
  /** Blocks Apply while the form holds an invalid value (e.g. To before From). */
  applyDisabled?: boolean;
  onReset: () => void;
  children: ReactNode;
  title?: string;
}

export default function MobileFilterDrawer({
  open,
  onClose,
  onApply,
  applyDisabled = false,
  onReset,
  children,
  title = "Filters",
}: MobileFilterDrawerProps) {
  const handleApply = useCallback(() => {
    onApply();
    onClose();
  }, [onApply, onClose]);

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen
      PaperProps={{
        sx: {
          borderRadius: "12px 12px 0 0",
          maxHeight: "75vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 16px",
          borderBottom: "1px solid #ccc",
          flexShrink: 0,
        }}
      >
        <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#1A1A1A" }}>
          {title}
        </Typography>
        <IconButton onClick={onClose} size="small" aria-label="Close filters">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* Content */}
      <Box sx={{ flex: 1, overflowY: "auto", padding: "12px 16px" }}>{children}</Box>

      {/* Footer */}
      <Box
        sx={{
          display: "flex",
          gap: "12px",
          padding: "10px 16px",
          borderTop: "1px solid #ccc",
          flexShrink: 0,
        }}
      >
        <Button variant="outlined" onClick={onReset} sx={{ flex: 1, minHeight: "36px" }}>
          Reset
        </Button>
        <Button variant="contained" onClick={handleApply} disabled={applyDisabled} sx={{ flex: 1, minHeight: "36px" }}>
          Apply
        </Button>
      </Box>
    </SwipeableDrawer>
  );
}
